import type { Category } from "@/types/models";

/**
 * Default annotation categories for new workspaces. Must stay in sync with
 * api/internal/services/workspace_service.go GetDefaultSharedData().
 */
export const DEFAULT_CATEGORIES: ReadonlyArray<Category> = [
  { label: "Setting", background: "#95c7e0" },
  { label: "Reasoning Step", background: "#609b91" },
  { label: "Target", background: "#ce7e8b" },
  { label: "Question", background: "#d4b86a" },
];

export const MAX_CATEGORIES = 5;

/**
 * Pick black or white chip text so it remains readable on the given hex
 * background. Threshold tuned to preserve the existing per-default chip
 * treatments in the create-workspace modal.
 */
export function getCategoryTextColor(hexBackground: string): string {
  const hex = hexBackground.replace("#", "");
  if (hex.length !== 6) return "#000";
  const r = parseInt(hex.slice(0, 2), 16);
  const g = parseInt(hex.slice(2, 4), 16);
  const b = parseInt(hex.slice(4, 6), 16);
  const luminance = 0.299 * r + 0.587 * g + 0.114 * b;
  return luminance > 155 ? "#000" : "#fff";
}
